import script from "./inventory.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventory.vue?vue&type=script&setup=true&lang=ts"

import "./inventory.vue?vue&type=style&index=0&id=4e26c74c&lang=scss"

const __exports__ = script;

export default __exports__